module.exports = __webpack_public_path__ + "img/teacher_03.cfdd86de.png";